import { Zap } from "lucide-react";

export const Marquee = ({ items }) => (
  <div data-testid="tech-marquee" className="relative overflow-hidden border-y border-cyan-500/10 bg-[#F8FAFC] py-5">
    <div className="flex w-max animate-marquee items-center gap-12">
      {[...items, ...items].map((item, i) => (
        <span key={i} className="flex items-center gap-12 font-mono text-sm uppercase tracking-[0.32em] text-slate-500">
          <span className="whitespace-nowrap transition-colors duration-300 hover:text-cyan-300">{item}</span>
          <Zap className="h-3.5 w-3.5 shrink-0 text-cyan-500/50" />
        </span>
      ))}
    </div>
    <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-volt-black to-transparent" />
    <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-volt-black to-transparent" />
  </div>
);
